module.exports = __webpack_public_path__ + "img/1ea4e06ece2ae35bb557cb5264383bdb.png";